import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListProductsComponent } from './components/list-products/list-products.component';
import { InfiniteScrollModule } from '@epicuro-next/ataraxia/infinite-scroll';
import { ProductCardModule } from '@epicuro-next/product-card';
import { FluidDragableListContentComponent } from './components/fluid-dragable-list-content/fluid-dragable-list-content.component';
import { SortablejsModule } from 'nxt-sortablejs';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { AtaraxiaPaginationLoaderModule } from '@epicuro-next/ataraxia/pagination-loader';
import { EmptyPlaceholderModule } from '@epicuro-next/ataraxia/empty-placeholder';
import { EnvironmentModule } from '@epicuro-next/platform/environment';
import { CategoryHeaderComponent } from './components/category-header/category-header.component';
import { MediaAspectRatioModule } from '@epicuro-next/ataraxia/media-aspect-ratio';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { RouterModule } from '@angular/router';
import { FullScreenModule } from '@epicuro-next/ataraxia/fullscreen';

@NgModule({
  imports: [
    CommonModule,
    InfiniteScrollModule,
    ProductCardModule,
    SortablejsModule,
    IconsModule,
    AtaraxiaPaginationLoaderModule,
    EmptyPlaceholderModule,
    EnvironmentModule,
    MediaAspectRatioModule,
    RouterModule,
    FullScreenModule,
  ],
  declarations: [
    ListProductsComponent,
    FluidDragableListContentComponent,
    CategoryHeaderComponent,
  ],
})
export class DynamicElementsListProductsModule {}

DontTreeShake(ListProductsComponent);
